import React from 'react';
import Icon from '../../assets/icons/remove.svg';

export default function AddIcon() {
  return (
    <img src={Icon} alt="remove" />
  );
}
